import React from 'react';// eslint-disable-line no-unused-vars
import Intl from 'intl';// eslint-disable-line no-unused-vars
import styles from './Base.scss';
import baseComponent from '../../decorators/baseComponent';
import Notifications from '../Notifications';
import {connect} from 'react-redux';
import {dismissNotification} from '../../actioncreators/AppActions.js';
//import messages from '../../messages';
import reactMixin from 'react-mixin';
import {IntlMixin} from 'react-intl';
import BaseReactComponent from '../Util/BaseReactComponent';

@reactMixin.decorate(IntlMixin)
@connect(state => ({
  notifications: state.notifications
}))
@baseComponent(styles) class Base extends BaseReactComponent {

  //componentDidMount() {
  //  window.addEventListener('popstate', this.handlePopState.bind(this));
  //}
  //
  //componentWillUnmount() {
  //  window.removeEventListener('popstate', this.handlePopState.bind(this));
  //}
  //
  //handlePopState(event) {
  //  this.context.router.transitionTo(window.location.pathname, {replace: !!event.state});
  //}

  dismissNotification(e, key, timeout) {
    //e.preventDefault();
    dismissNotification(key, timeout)(this.props.dispatch);
  }

  render() {
    return (
      <div>
        <Notifications notifications={this.props.notifications} onDismiss={this.dismissNotification.bind(this)}/>
        {this.props.children}
      </div>
    );
  }
}

//Base.defaultProps = intlData;

export default Base;



// WEBPACK FOOTER //
// /src/components/Base/Base.js